module.exports = __webpack_public_path__ + "static/media/banner.c7df1e3e.png";